import PropTypes from 'prop-types';
import React from 'react';
import { REP_VISITS_SUBSCRIPTION } from '../Authorization/constants';
import SidebarWrapper from '../../components/SidebarWrapper';
import RepVisitsOverviewPage from '../RepVisitsOverviewPage';
import RepVisitsOverviewUnlockPage from '../RepVisitsOverviewPage/repvisits-overview-unlock';
import './styles.css';

class RepVisitsOverviewFrame extends React.PureComponent {
  static propTypes = {
    viewer: PropTypes.object,
  };

  state = {
    sidebarComponent: null,
    sidebarVisible: false,
  };

  displaySidebarComponent = (component) => {
    /* istanbul ignore else */
    if (component) {
      this.setState({
        sidebarVisible: true,
        sidebarComponent: component,
      });
    }
  };

  closeSidebar = () => {
    /* istanbul ignore else */
    if (this.state.sidebarVisible) {
      this.setState({ sidebarVisible: false });
    }
  };

  render() {
    const { viewer: { heAccount: { activeSubscriptions } } } = this.props;
    const { sidebarVisible, sidebarComponent } = this.state;
    return (
      <div styleName="overview-container">
        {activeSubscriptions.includes(REP_VISITS_SUBSCRIPTION) ? (
          <SidebarWrapper>
            <SidebarWrapper.Content dimmed={sidebarVisible} onClick={this.closeSidebar}>
              <div styleName="top-container">
                <div styleName="container">
                  <RepVisitsOverviewPage
                    displaySidebarComponent={this.displaySidebarComponent}
                    closeSidebar={this.closeSidebar}
                  />
                </div>
              </div>
            </SidebarWrapper.Content>
            {sidebarComponent && React.cloneElement(sidebarComponent, { visible: sidebarVisible, onClose: this.closeSidebar })}
          </SidebarWrapper>
        ):
          <RepVisitsOverviewUnlockPage />}
      </div>
    );
  }
}

export default RepVisitsOverviewFrame;
